// webpackPrefetch: tarayıcı boştayken bu chunk'ları arka planda indirir
export const loadAboutPage = () => import(/* webpackChunkName: "about", webpackPrefetch: true */ "@/pages/AboutPage");
export const loadServicesPage = () => import(/* webpackChunkName: "services", webpackPrefetch: true */ "@/pages/ServicesPage");
export const loadProjectsPage = () => import(/* webpackChunkName: "projects", webpackPrefetch: true */ "@/pages/ProjectsPage");
export const loadProjectDetailPage = () => import(/* webpackChunkName: "project-detail", webpackPrefetch: true */ "@/pages/ProjectDetailPage");
export const loadContactPage = () => import(/* webpackChunkName: "contact", webpackPrefetch: true */ "@/pages/ContactPage");
export const loadDreamsPage = () => import(/* webpackChunkName: "dreams", webpackPrefetch: true */ "@/pages/DreamsPage");

// En sık ziyaret edilen sayfalar önce, 800ms aralıklarla — main thread'e nefes aldır
export const warmRouteChunks = () => {
  const tasks = [
    loadProjectsPage,      // En önemli: proje sayfası
    loadProjectDetailPage, // İkinci: proje detayı
    loadAboutPage,
    loadServicesPage,
    loadContactPage,
    loadDreamsPage,
  ];

  tasks.forEach((task, index) => {
    window.setTimeout(task, 800 * (index + 1));
  });
};

const heroImages = [
  "/images/2-anasayfa/anasayfa_opt.webp",
  "/images/3-hakkimizda/hakkimizda_opt.webp",
  "/images/4-hizmetler/hizmetler_opt.webp",
  "/images/6-iletisim/iletisim_opt.webp",
  "/images/7-dreams/dreams_opt.webp",
];

export const preloadRouteImages = () => {
  heroImages.forEach((src) => {
    const link = document.createElement("link");
    link.rel = "prefetch";
    link.as = "image";
    link.href = src;
    document.head.appendChild(link);
  });
};

// İlk hero dışındaki görselleri tarayıcı boştayken 200ms aralıklarla ısıt
export const warmHeroImages = () => {
  const secondary = heroImages.slice(1);
  const load = (index) => {
    if (index >= secondary.length) return;
    const img = new Image();
    img.src = secondary[index];
    window.setTimeout(() => load(index + 1), 200);
  };
  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(() => load(0), { timeout: 4000 });
  } else {
    window.setTimeout(() => load(0), 1000);
  }
};
